// extracted by mini-css-extract-plugin
module.exports = {"over":"operationDetail_over__2QHW_","cancel":"operationDetail_cancel__1uDlq","container":"operationDetail_container__1gE8Z","containerP":"operationDetail_containerP__3kU9h"};